import getOverlapsOfPotentiallyCircularRanges from "./getOverlapsOfPotentiallyCircularRanges";
import splitRangeIntoTwoPartsIfItIsCircular from "./splitRangeIntoTwoPartsIfItIsCircular";
import trimNonCicularRangeByAnotherNonCircularRange from "./trimNonCicularRangeByAnotherNonCircularRange";
import { extend } from "lodash-es";
export default function trimRangeByAnotherRange(rangeToBeTrimmed, trimmingRange, sequenceLength) {
  if (!rangeToBeTrimmed || !trimmingRange) {
    console.warn("invalid range input");
    return null;
  }
  let position;
  for (position of [
    rangeToBeTrimmed.start,
    rangeToBeTrimmed.end,
    trimmingRange.start,
    trimmingRange.end
  ]) {
    if (position < 0 || !position && position !== 0) {
      console.warn("invalid range input");
      return null;
    }
  }
  const overlaps = getOverlapsOfPotentiallyCircularRanges(
    rangeToBeTrimmed,
    trimmingRange,
    sequenceLength
  );
  if (!overlaps.length) {
    return rangeToBeTrimmed;
  }
  const splitRangesToBeTrimmed = splitRangeIntoTwoPartsIfItIsCircular(
    rangeToBeTrimmed,
    sequenceLength
  );
  splitRangesToBeTrimmed.forEach(function(nonCircularRangeToBeTrimmed, index) {
    overlaps.forEach(function(overlap) {
      if (nonCircularRangeToBeTrimmed) {
        nonCircularRangeToBeTrimmed = trimNonCicularRangeByAnotherNonCircularRange(
          nonCircularRangeToBeTrimmed,
          overlap
        );
      }
    });
    splitRangesToBeTrimmed[index] = nonCircularRangeToBeTrimmed;
  });
  const outputSplitRanges = splitRangesToBeTrimmed.filter(
    function(trimmedRange) {
      if (trimmedRange) {
        return true;
      }
      return false;
    }
  );
  let outputTrimmedRange;
  if (outputSplitRanges.length < 0) {
  } else if (outputSplitRanges.length === 1) {
    outputTrimmedRange = outputSplitRanges[0];
  } else if (outputSplitRanges.length === 2) {
    if (outputSplitRanges[0].start < outputSplitRanges[1].start) {
      outputTrimmedRange = {
        start: outputSplitRanges[1].start,
        end: outputSplitRanges[0].end
      };
    } else {
      outputTrimmedRange = {
        start: outputSplitRanges[0].start,
        end: outputSplitRanges[1].end
      };
    }
  }
  if (outputTrimmedRange) {
    return extend({}, rangeToBeTrimmed, {
      start: outputTrimmedRange.start,
      end: outputTrimmedRange.end
    });
  }
}
